import { WidgetFeatureType } from '../enums/widget-feature.enum';
import type { IConfigStore } from '../interfaces/store-config.interface';

export type ConfigDefaultsVersion = 1 | 2;

type VersionedConfigKey =
  | 'canClearChatHistory'
  | 'reasoningMode'
  | 'loadThreadHistory'
  | 'sessionInactivityTimeout'
  | 'features'
  | 'scrollBehavior'
  | 'isTextAreaSearch';

const VERSION_2_DEFAULTS: Pick<IConfigStore, VersionedConfigKey> = {
  canClearChatHistory: true,
  reasoningMode: 'full',
  loadThreadHistory: true,
  sessionInactivityTimeout: 43200,
  features: [
    {
      name: WidgetFeatureType.addFiles,
      enabled: true,
      customConfig: { numberOfFiles: 3, maxFileSizeMb: 10 },
    },
  ],
  scrollBehavior: true,
  isTextAreaSearch: true,
};

/**
 * Return only the versioned defaults which are not defined by the option
 * payload. This preserves explicit values such as false, 0, and an empty
 * features array.
 */
export function getOptionConfigDefaults(
  defaultsVersion: ConfigDefaultsVersion | undefined,
  optionConfig: Partial<IConfigStore>
): Partial<Pick<IConfigStore, VersionedConfigKey>> {
  if (defaultsVersion !== 2) return {};

  return Object.fromEntries(
    Object.entries(VERSION_2_DEFAULTS).filter(
      ([key]) => optionConfig[key as VersionedConfigKey] === undefined
    )
  ) as Partial<Pick<IConfigStore, VersionedConfigKey>>;
}
